// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"34e11932","900":"fee16126","963":"c0bcef78"}[chunkId] + ".chunk.js";
};